<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="collections"
          description
          search
          @selected="openView"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.collection_profile") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                @click="$router.push({ name: 'Create Collection Profile' })"
                size="small"
                >{{ $t("setup.label.create_collection_profile") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.collection_profile_id") }}</vs-th>
            <vs-th>{{ $t("setup.label.Name") }}</vs-th>
            <vs-th>{{ $t("setup.label.CustomerType") }}</vs-th>
            <vs-th>{{ $t("setup.label.ServiceType") }}</vs-th>
            <vs-th>{{ $t("setup.label.jobTitle") }}</vs-th>
            <vs-th>{{ $t("setup.label.creditScore") }}</vs-th>
            <vs-th>{{ $t("setup.label.region") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="collectionProfile"
              v-for="(collectionProfile, index) in data"
            >
              <vs-td :data="collectionProfile.profileId">{{
                collectionProfile.profileId
              }}</vs-td>
              <vs-td :data="collectionProfile.collectionName">{{
                collectionProfile.collectionName
              }}</vs-td>
              <vs-td :data="collectionProfile.customerType">{{
                collectionProfile.customerType
              }}</vs-td>
              <vs-td :data="collectionProfile.serviceId">{{
                collectionProfile.serviceId
              }}</vs-td>
              <vs-td :data="collectionProfile.jobTitle">{{
                collectionProfile.jobTitle
              }}</vs-td>
              <vs-td :data="collectionProfile.creditScore">{{
                collectionProfile.creditScore
              }}</vs-td>
              <vs-td :data="collectionProfile.regionCode">{{
                collectionProfile.regionCode
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('setup.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editData(collectionProfile.profileId)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = collectionProfile.profileId;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <delete-popup
        :deletePopup="deleteItemPopup"
        :title="$t('setup.label.collection')"
        @deletePressed="removeCollection(delId)"
        @cancelPressed="deleteItemPopup = false"
      >
      </delete-popup>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      collections: (state) => state.collectionProfile.collections,
    }),
  },
  methods: {
    async getCollectionList() {
      this.loading = true;
      try {
        await this.$store.dispatch("collectionProfile/fetchCollectionList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
      this.loading = false;
    },
    editData(id) {
      this.$router.push({
        name: "Edit Collection Profile",
        params: { id: id },
      });
    },
    openView(collections) {
      this.$router.push({
        name: "Collection Detail",
        params: { id: collections.profileId },
      });
    },
    async removeCollection(id) {
      try {
        await this.$store.dispatch(
          "collectionProfile/deleteCollectionAction",
          id
        );
        this.deleteItemPopup = false;
        await this.$toasted.success("Deleted Successfully", {
          duration: 2000,
        });
        await this.getCollectionList();
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.getCollectionList();
  },
};
</script>

<style lang="scss"></style>
